module.exports = __webpack_public_path__ + "static/media/logo_white.372a5cd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/logo_white.svg
// module id = 3367
// module chunks = 0